import script from "./payplat.vue?vue&type=script&setup=true&lang=js"
export * from "./payplat.vue?vue&type=script&setup=true&lang=js"

import "./payplat.vue?vue&type=style&index=0&id=52b3f7ea&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b3f7ea"]])

export default __exports__